import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../store/actions';
import { Button, Dialog, makeStyles } from '@material-ui/core';
import { ITheme } from '../themes/custom/ITheme';
import SnackBarType from '../objects/app/snackbar';
import { IIndexable } from '../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import * as ValidateModel from '../shared/ValidateModel';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';
import BuyDialog from '../components/BuyDialog/BuyDialog';
import KapinuaDialogTitle from '../components/KapinuaDialog/KapinuaDialogTitle';
import SaveDesignNameDialog from '../components/SaveDesignNameDialog/SaveDesignNameDialog';
import TeamDialog, {
    IMember,
    ISavedTeamMember,
} from '../components/TeamDialog/TeamDialog';
import { setMembers as setMembersAction } from '../store/actions/onlineDesignerAction';
import BottomMenu from '../components/BottomMenu/BottomMenu';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import theme from '../themes/GlobalTheme';
import i18next from '../localization/init';

const useStyles = makeStyles((theme: ITheme) => {
    return {
        dialog: {
            padding: '2rem',
        },
        closeButton: {
            color: theme.custom.palette.secondary,
        },
        dialogActions: {
            padding: '18px 24px',
        },
        dialogTitle: {
            height: '48px',
            padding: '0px 37px',
            lineHeight: '48px',
        },
        back: {
            fontSize: '15px',
        },
        editButton: {
            color: theme.custom.palette.white,
            marginLeft: '10px',
            padding: '0px',
            textTransform: 'none',
            fontSize: '15px',
        },
    };
});

interface Props {
    onSubmitFuncName: string;
    sizeImg: string;
    proofServiceLink: string;
    customerId: number | null;
    guestId: number | null;
    admin: boolean;
}

declare global {
    interface Window {
        openBuyDialog: any;
        GET_SELECTED_SIZES_FCE_NAME: string;
        GET_SELECTED_FABRIC_FCE_NAME: string;
        GET_ID_DESIGN_FCE_NAME: string;
        GET_ID_PRODUCT_FCE_NAME: string;
        GET_ID_LANGUAGE_FCE_NAME: string;
        GET_ID_CURRENCY_FCE_NAME: string;
        GET_ADD_ONS_PRICE_FCE_NAME: string;
        GET_DESIGN_EXTRA_PRICE_FCE_NAME: string;
        GET_IS_TEAM_FCE_NAME: string;
    }
}

export interface ISelectedSize {
    id: string | number;
    name: string;
    count: string | number;
}

export interface IFabric {
    id: string | number;
    name: string;
}

const BuyDialogContainer: React.FC<Props> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [designNameDialogIsOpen, setDesignNameDialogIsOpen] = useState(false);
    const [teamDialogIsOpen, setTeamDialogIsOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { admin, onSubmitFuncName, proofServiceLink, sizeImg, customerId, guestId } =
        props;

    const [isOpen, setIsOpen] = useState(false);
    const [goToCheckout, setGoToCheckout] = useState(false);
    const {
        data: productData,
        loading: productLoading,
        success: productSuccess,
    } = useTypedSelector((state) => state.od.loadProduct);
    const { data: selectedData } = useTypedSelector(
        (state) => state.od.selected
    );
    const { data: cartItemsData, loading: cartItemsLoading } = useTypedSelector(
        (state) => state.buyDialog.loadCartItems
    );
    const { data: teamData } = useTypedSelector((state) => state.od.team);

    useEffect(() => {
        try {
            ValidateModel.isWindowFce(
                'GET_SELECTED_SIZES_FCE_NAME',
                window.GET_SELECTED_SIZES_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_SELECTED_FABRIC_FCE_NAME',
                window.GET_SELECTED_FABRIC_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_ID_DESIGN_FCE_NAME',
                window.GET_ID_DESIGN_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_ID_PRODUCT_FCE_NAME',
                window.GET_ID_PRODUCT_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_ID_LANGUAGE_FCE_NAME',
                window.GET_ID_LANGUAGE_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_ID_CURRENCY_FCE_NAME',
                window.GET_ID_CURRENCY_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_ADD_ONS_PRICE_FCE_NAME',
                window.GET_ADD_ONS_PRICE_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_DESIGN_EXTRA_PRICE_FCE_NAME',
                window.GET_DESIGN_EXTRA_PRICE_FCE_NAME
            );
            ValidateModel.isWindowFce(
                'GET_IS_TEAM_FCE_NAME',
                window.GET_IS_TEAM_FCE_NAME
            );
            ValidateModel.isWindowFceCallable(
                'onSubmitFuncName',
                onSubmitFuncName
            );
        } catch (error: any) {
            dispatch(
                actions.addSnackbar(
                    t('Buy dialog is not properly defined. ') + error.message,
                    SnackBarType.WARNING,
                    false
                )
            );
        }

        if (productData === null && !productLoading) {
            initiateLoadProduct();
        }

        window.openBuyDialog = (goToCheckoutVal: boolean = false) => {
            setIsOpen(true);
            setGoToCheckout(goToCheckoutVal);
        };

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (productData !== null) {
            if (teamData === null) {
                initiateLoadTeam();
            }
        }
        if (productSuccess && productData?.language) {
            i18next.changeLanguage(productData.language);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productData]);

    const initiateLoadProduct = () => {
        setTimeout(() => {
            const idProduct = (window as IIndexable)[
                window.GET_ID_PRODUCT_FCE_NAME
            ]();
            const idLang = (window as IIndexable)[
                window.GET_ID_LANGUAGE_FCE_NAME
            ]();
            const idCurrency = (window as IIndexable)[
                window.GET_ID_CURRENCY_FCE_NAME
            ]();
            if (idProduct > 0 && idLang > 0) {
                dispatch(actions.loadProduct(idProduct, idLang, idCurrency));
                if (isOpen && cartItemsData === null && !cartItemsLoading) {
                    dispatch(actions.loadCart(customerId, guestId));
                }
            } else {
                initiateLoadProduct();
            }
        }, 200);
    };

    const initiateLoadTeam = () => {
        setTimeout(() => {
            const savedMembers = (window as IIndexable)[
                window.GET_SAVED_TEAM_FCE_NAME
            ]();
            if (savedMembers !== null && productData !== null) {
                const members: IMember[] = [];

                savedMembers.forEach((savedMember: ISavedTeamMember) => {
                    const productSize = productData.sizes
                        .filter((size) => size.name === savedMember.size)
                        .pop();

                    members.push({
                        name: savedMember.name,
                        number: savedMember.number,
                        size: productSize ?? null,
                        id: Math.random() * 1000,
                    });
                });
                (window as IIndexable)[window.SET_TEAM_FCE_NAME](members);
                dispatch(setMembersAction(members));
            } else {
                initiateLoadTeam();
            }
        }, 500);
    };

    const idDesign = (window as IIndexable)[window.GET_ID_DESIGN_FCE_NAME]();

    const idProduct = (window as IIndexable)[window.GET_ID_PRODUCT_FCE_NAME]();

    const designName = (window as IIndexable)[
        window.GET_DESIGN_NAME_FCE_NAME
    ]();

    const handleOnClose = () => {
        setIsOpen(false);
    };

    const handleOnSubmit = (addProofService: boolean) => {
        window.startSaveDesign(
            idDesign,
            idProduct,
            designName.length === 0,
            onSubmitFuncName,
            selectedData,
            teamData,
            false,
            { goToCheckout },
            true,
            addProofService
        );

        handleOnClose();
    };

    return (
        <React.Fragment>
            <BottomMenu
                startSaveAs={() => {
                    window.startSaveDesign(
                        idDesign,
                        (window as IIndexable)[
                            window.GET_ID_PRODUCT_FCE_NAME
                        ](),
                        true,
                        'onSuccessSaveDesign',
                        selectedData,
                        teamData,
                        false,
                        null,
                        false,
                        false,
                        true
                    );
                }}
                startSave={() => {
                    window.startSaveDesign(
                        idDesign,
                        (window as IIndexable)[
                            window.GET_ID_PRODUCT_FCE_NAME
                        ](),
                        designName.length === 0,
                        'onSuccessSaveDesign',
                        selectedData,
                        teamData,
                        false,
                        null,
                        false,
                        false,
                        false
                    );
                }}
                openBuyDialog={() => {
                    setIsOpen(true);
                    setGoToCheckout(true);
                }}
            />
            <SaveDesignNameDialog
                isOpen={designNameDialogIsOpen}
                onClose={() => {
                    setDesignNameDialogIsOpen(false);
                }}
                customerId={customerId}
                guestId={guestId}
            />
            <TeamDialog
                isOpen={teamDialogIsOpen}
                onClose={() => {
                    setTeamDialogIsOpen(false);
                }}
            />
            <Dialog
                onClose={handleOnClose}
                open={isOpen}
                fullWidth={true}
                maxWidth={'md'}
            >
                <KapinuaDialogTitle
                    handleOnClose={handleOnClose}
                    backText={isMobile ? undefined : t('< Back to Designer')}
                    closeIcon={isMobile}
                >
                    {!isMobile && (
                        <React.Fragment>
                            {t('Order your design ')}
                        </React.Fragment>
                    )}
                    {isMobile && <React.Fragment>{t('Order ')}</React.Fragment>}

                    {designName && designName.length > 0 && (
                        <React.Fragment>
                            <span>-</span>{' '}
                            <strong>
                                {isMobile
                                    ? designName.substring(0, 10) +
                                      (designName.length > 10 ? '..' : '')
                                    : designName}
                            </strong>
                        </React.Fragment>
                    )}
                    {idDesign > 0 && (
                        <React.Fragment>
                            {!isMobile && (
                                <Button
                                    className={classes.editButton}
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    onClick={() => {
                                        setDesignNameDialogIsOpen(true);
                                    }}
                                >
                                    {t('Edit')}
                                </Button>
                            )}
                            {isMobile && (
                                <EditIcon
                                    fontSize="small"
                                    className={classes.editButton}
                                    onClick={() => {
                                        setDesignNameDialogIsOpen(true);
                                    }}
                                ></EditIcon>
                            )}
                        </React.Fragment>
                    )}
                </KapinuaDialogTitle>
                <BuyDialog
                    customerId={customerId}
                    guestId={guestId}
                    proofServiceLink={proofServiceLink}
                    sizeImg={sizeImg}
                    isMobile={isMobile}
                    onSubmit={handleOnSubmit}
                    openTeamDialog={() => setTeamDialogIsOpen(true)}
                    closeTeamDialog={() => setTeamDialogIsOpen(false)}
                    admin={admin}
                />
            </Dialog>
        </React.Fragment>
    );
};

export default BuyDialogContainer;
